import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatDialogModule } from '@angular/material/dialog';
import { VznDataTableModule, TranslationService } from '@noammazuz/vzn-data-table';
import { AuthService, RestApiService, VznFeathersModule } from '@noammazuz/vzn-feathers';
import { environment } from '@environmentsenvironment';
import { VznLoginModule } from '@noammazuz/vzn-login';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { SplashScreenComponent } from './pages/splash-screen/splash-screen.component';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AppHeaderComponent } from '../layouts/full/header/header.component';
import { AppSidebarComponent } from '../layouts/full/sidebar/sidebar.component';
import { SharedModule } from '../shared/shared.module';
import { ConfirmDialogModule } from '../shared/confirm-dialog/confirm-dialog.module';
import { SitesPageComponent } from './pages/sites-page/sites-page.component';
import { SiteDetailsPageComponent } from './pages/site-details-page/site-details-page.component';
import { VznMediaModule } from '@noammazuz/vzn-media';
import { MailListTableComponent } from './pages/mail-list-table/mail-list-table.component';
import { MailListDetailsComponent } from './pages/mail-list-details/mail-list-details.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { EmailTableComponent } from './pages/email-table/email-table.component';
import { EmailDetailsComponent } from './pages/email-details/email-details.component';
import { QuillModule } from 'ngx-quill';
import { SiteComponent } from './pages/site/site.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { MonacoEditorModule } from 'ngx-monaco-editor';
import { P404Component } from './pages/p404/p404.component';
import { LogTableComponent } from './pages/log-table/log-table.component';
import { EditorComponent } from './components/editor/editor.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { ColorPickerModule } from 'ngx-color-picker';
import { ScrollingModule } from '@angular/cdk/scrolling';

@NgModule({
  declarations: [
    AppComponent,
    AppHeaderComponent,
    AppSidebarComponent,
    LoginPageComponent,
    SplashScreenComponent,
    SitesPageComponent,
    SiteDetailsPageComponent,
    MailListTableComponent,
    MailListDetailsComponent,
    EmailTableComponent,
    EmailDetailsComponent,
    SiteComponent,
    ConfirmDialogComponent,
    P404Component,
    LogTableComponent,
    EditorComponent
  ],
  imports: [
    MatDialogModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    VznDataTableModule,
    VznFeathersModule.forRoot(environment.vznFeathers),
    VznMediaModule.forRoot({ defaultImgSrc: 'assets/images/image_placeholder.png', maxImageSize: 4096 }),
    VznLoginModule,
    ConfirmDialogModule,
    FlexLayoutModule,
    QuillModule.forRoot(),
    ClipboardModule,
    MonacoEditorModule.forRoot(),
    MatSlideToggleModule,
    MatSelectModule,
    ColorPickerModule,
    ScrollingModule
  ],
  entryComponents: [ ConfirmDialogComponent ],
  providers: [
    TranslationService,
    TranslateService,
    RestApiService, AuthService,
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}